import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { List, Typography } from '@mui/material';
import { $contactCalls } from '../../model/calls';
import { Call } from '../../model/calls/types';
import { $isLoading } from '../../model/main';
import { CallData } from './call-data';
import { CallDateAndStatus } from './call-date-and-status';
import { PhoneIcon } from './phone-icon';
import * as Styled from './styled';

const RESIDENTS_URL = 'residents-new';

export const CallsList = () => {
  const { t } = useTranslation();
  const [contactCalls, isLoading] = useUnit([$contactCalls, $isLoading]);

  if (isLoading) return null;

  if (contactCalls.length)
    return (
      <Styled.List>
        {contactCalls.map((data) => (
          <CallItem key={data.call.id} {...data} />
        ))}
      </Styled.List>
    );

  return (
    <List>
      <Styled.ListItemNoData>
        <Typography variant="body1" color="textSecondary">
          {t('CallListSsEmpty')}
        </Typography>
      </Styled.ListItemNoData>
    </List>
  );
};

const CallItem = ({ call, resident }: Call) => {
  const residenListItem = (
    <Styled.ListItem>
      <Styled.LeftItems>
        <PhoneIcon {...call} />

        <CallData call={call} resident={resident} />
      </Styled.LeftItems>

      <CallDateAndStatus {...call} />
    </Styled.ListItem>
  );

  return resident ? (
    <Styled.Link
      href={`/${RESIDENTS_URL}/${resident.id}`}
      target="_blank"
      color="inherit"
      underline="none"
    >
      {residenListItem}
    </Styled.Link>
  ) : (
    residenListItem
  );
};
